import { Mui, MuiIcons } from "@osu/react-ui";
import {
  selectDescriptionList,
  selectMetadataValues,
} from "../../../services/form/slices";
  import { useParams } from "react-router-dom";
import { shallowEqual as equalitySelector, useSelector } from "react-redux";

const selectSummaryLevelFields = (state, type, id) => {
  const {
    foreignSourceName,
    countryOfAttribution,
    sourceAmount
  } = selectMetadataValues(state, type, id);
  return [
    foreignSourceName || `No Foreign Source Name`,
    countryOfAttribution || `No Country of Attribution`,
    sourceAmount ? `$${sourceAmount}` : `No Source Amount`,
  ].filter(Boolean)
}

function Summary() {
  const { id, type } = useParams();
  const highestLevelFields = useSelector((state) => {
    return selectSummaryLevelFields(state, type, id);
  }, equalitySelector);

  return highestLevelFields.map((field, index) => {
    if (index === 0) {
      return (
        <Mui.Typography variant="subtitle2" component="span" sx={{ whiteSpace: "pre", display: "inline-flex", alignItems: "center" }}>
          {field}
        </Mui.Typography>
      );
    }
    return (
      <Mui.Typography
        variant="body2"
        component="span"
        sx={{ whiteSpace: "pre", display: "inline-flex", alignItems: "center" }}
      >
        {"  |  "}
        {field}
      </Mui.Typography>
    );
  });
}

function MetadataList(props = {}) {
  const { id, type } = useParams();
  const descriptors = useSelector((state) => {
    return selectDescriptionList(state, type, id);
  }, equalitySelector);

  return (
    <Mui.Accordion sx={{
          marginBottom: 2
    }} slotProps={{ heading: { component: "div" } }}>
      <Mui.AccordionSummary
        expandIcon={<MuiIcons.ArrowDropDown />}
        aria-controls="metadata-content"
        id="metadata-header"
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Summary />
      </Mui.AccordionSummary>
      <Mui.AccordionDetails
        sx={{
          padding: 0,
          margin: 0,
        }}
      >
        <Mui.Box component="dl" {...props}>
          {descriptors.map(
            ({ field: title, value: description }, index) => (
              <Mui.Box key={index + `${encodeURIComponent(title)}`}>
                <Mui.Typography color="text.secondary" component="dt" variant="overline">
                  {title}
                </Mui.Typography>
                <Mui.Typography component="dd" variant="caption">
                    {description}
                  </Mui.Typography>
              </Mui.Box>
            )
          )}
        </Mui.Box>
      </Mui.AccordionDetails>
    </Mui.Accordion>
  );
}

export default MetadataList;
